import { MapSettingEnum } from '../../../../shared/GameEnums.ts';
import { clientI18n } from '../ClientI18n.ts';
import { isMapLockedForUser } from '../ui_utils/isMapLockedForUser.ts';
import { getItemInfoSubscribeAction } from './getItemInfoSubscribeAction.ts';
import { showRoomItemInfoDialog } from './showRoomItemInfoDialog.ts';
export function showMapInfoDialog(mapData) {
    showRoomItemInfoDialog({
        title: mapData.name,
        image: mapData.image,
        bodyText: getMapInfoBody(mapData.mapEnum),
        onSubscribe: getItemInfoSubscribeAction(isMapLockedForUser(mapData), MapSettingEnum[mapData.mapEnum], 'map')
    });
}
function getMapInfoBody(mapEnum) {
    switch(mapEnum){
        case MapSettingEnum.Classic4P:
            return clientI18n.t('strings:colonistCommon.gameMaps.classic.4P.description');
        case MapSettingEnum.Classic4PRandom:
            return clientI18n.tArray('strings:colonistCommon.gameMaps.classic.random4P.description').join('');
        case MapSettingEnum.SS1HeadingForNewShores3P:
            return clientI18n.t('strings:colonistCommon.gameMaps.seafarers.headingForNewShores', {
                count: 3
            });
        case MapSettingEnum.SS1HeadingForNewShores4P:
            return clientI18n.t('strings:colonistCommon.gameMaps.seafarers.headingForNewShores', {
                count: 4
            });
        case MapSettingEnum.SS1HeadingForNewShores56P:
            return clientI18n.t('strings:colonistCommon.gameMaps.seafarers.headingForNewShores', {
                count: 6
            });
        case MapSettingEnum.TutorialSS1HeadingForNewShores4P:
            return clientI18n.t('strings:colonistCommon.gameMaps.seafarers.tutorialHeadingForNewShores4P');
        case MapSettingEnum.SS2FourIslands3P:
            return clientI18n.t('strings:colonistCommon.gameMaps.seafarers.fourIslands', {
                count: 3
            });
        case MapSettingEnum.SS2FourIslands4P:
            return clientI18n.t('strings:colonistCommon.gameMaps.seafarers.fourIslands', {
                count: 4
            });
        case MapSettingEnum.SS2SixIslands56P:
            return clientI18n.t('strings:colonistCommon.gameMaps.seafarers.sixIslands');
        case MapSettingEnum.TutorialSS2FourIslands4P:
            return clientI18n.t('strings:colonistCommon.gameMaps.seafarers.tutorialFourIslands4P');
        case MapSettingEnum.SS3FogIslands3P:
            return clientI18n.t('strings:colonistCommon.gameMaps.seafarers.fogIslands', {
                count: 3
            });
        case MapSettingEnum.SS3FogIslands4P:
            return clientI18n.t('strings:colonistCommon.gameMaps.seafarers.fogIslands', {
                count: 4
            });
        case MapSettingEnum.SS3FogIslands56P:
            return clientI18n.t('strings:colonistCommon.gameMaps.seafarers.fogIslands', {
                count: 6
            });
        case MapSettingEnum.TutorialSS3FogIsland4P:
            return clientI18n.t('strings:colonistCommon.gameMaps.seafarers.tutorialFogIslands4P');
        case MapSettingEnum.SS4ThroughTheDesert3P:
            return clientI18n.t('strings:colonistCommon.gameMaps.seafarers.throughTheDesert', {
                count: 3
            });
        case MapSettingEnum.SS4ThroughTheDesert4P:
            return clientI18n.t('strings:colonistCommon.gameMaps.seafarers.throughTheDesert', {
                count: 4
            });
        case MapSettingEnum.SS4ThroughTheDesert56P:
            return clientI18n.t('strings:colonistCommon.gameMaps.seafarers.throughTheDesert', {
                count: 6
            });
        case MapSettingEnum.TutorialSS4ThroughTheDesert4P:
            return clientI18n.t('strings:colonistCommon.gameMaps.seafarers.tutorialThroughTheDesert4P');
        case MapSettingEnum.Earth:
            return clientI18n.tArray('strings:colonistCommon.gameMaps.fun.earth.description').join('');
        case MapSettingEnum.EarthSeafarers:
            return clientI18n.tArray('strings:colonistCommon.gameMaps.fun.earth.description').join('');
        case MapSettingEnum.USA:
            return clientI18n.tArray('strings:colonistCommon.gameMaps.fun.usa.description').join('');
        case MapSettingEnum.UK:
            return clientI18n.tArray('strings:colonistCommon.gameMaps.fun.uk.description').join('');
        case MapSettingEnum.UKSeafarers:
            return clientI18n.tArray('strings:colonistCommon.gameMaps.fun.uk.description').join('');
        case MapSettingEnum.Diamond:
            return clientI18n.tArray('strings:colonistCommon.gameMaps.fun.diamond.description').join('');
        case MapSettingEnum.Gear:
            return clientI18n.tArray('strings:colonistCommon.gameMaps.fun.gear.description').join('');
        case MapSettingEnum.Lakes:
            return clientI18n.tArray('strings:colonistCommon.gameMaps.fun.lakes.description').join('');
        case MapSettingEnum.Pond:
            return clientI18n.tArray('strings:colonistCommon.gameMaps.fun.pond.description').join('');
        case MapSettingEnum.Twirl:
            return clientI18n.tArray('strings:colonistCommon.gameMaps.fun.twirl.description').join('');
        case MapSettingEnum.ShuffleBoard:
            return clientI18n.tArray('strings:colonistCommon.gameMaps.fun.shuffleBoard.description').join('');
        case MapSettingEnum.BlackForest:
            return clientI18n.tArray('strings:colonistCommon.gameMaps.fun.blackForest.description').join('');
        case MapSettingEnum.Volcano:
            return clientI18n.tArray('strings:colonistCommon.gameMaps.fun.volcano.description').join('');
        case MapSettingEnum.GoldRush:
            return clientI18n.tArray('strings:colonistCommon.gameMaps.fun.goldRush.description').join('');
        default:
            return '';
    }
}
